import styled from 'styled-components';
import { crTheme, Text } from '@comicrelief/component-library';

const AsteriskWrapper = styled(Text)`
  margin: 30px 0;
  text-align: center;
  font-size: 0.75rem;
`;

const LegalTextButton = styled.button`
  border: none;
  background: none;
  color: ${crTheme.color('blue_donate')};
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
`;

const PaymentButtonsSingleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PaymentButtonRow = styled.div`
  box-sizing: border-box;
  flex: 0 0 50px;
  height: 50px;
  min-height: 50px;
  width: 100%;
`;

const PaymentButtonRowInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
`;

export {
  AsteriskWrapper,
  PaymentButtonsSingleSection,
  PaymentButtonRow,
  PaymentButtonRowInner,
  LegalTextButton
};
